import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { UserInfoService } from "src/app/services/user-info.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { FooterVisibilityService } from "src/app/services/footer-visibility.service";
import { browserRefresh } from "../../app.component";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-payment-choose-plan",
  templateUrl: "./payment-choose-plan.component.html",
  styleUrls: ["./payment-choose-plan.component.scss"],
})
export class PaymentChoosePlanComponent implements OnInit {
  public toggleDiscoundCode: boolean = false;
  public browserRefresh: boolean;
  public chosenPlan;
  public planPaymentType;
  public chosenPaymentType;
  public id;
  public myUser;
  public Subscription: Subscription;
  public submitted = false;
  public paymentFee;
  public paymentPeriod;
  // Form Payment Type
  public choosePlanFormGroup: FormGroup = new FormGroup({
    planPaymentType: new FormControl("perYear"),
    hasDiscountCode: new FormControl(false),
    selectOrganization: new FormControl(""),
    discountCode: new FormControl(""),
  });
  public myPlanHolder: any;



  constructor(
    private userInfoService: UserInfoService,
    private zenplansDataService: ZpDataService,
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private footerVisibilityService: FooterVisibilityService,
    public themeService: ThemeService
  ) { }

  async ngOnInit() {



    this.browserRefresh = browserRefresh;
    this.chosenPlan = "perYear";
    this.paymentFee = 72;
    this.paymentPeriod = "year";
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.footerVisibilityService.hideFooter = true;
    this.Subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
    await this.getMyUser();

    // Form Payment Type
    this.choosePlanFormGroup.addControl(
      "planPaymentType",
      new FormControl(this.myUser.planPaymentType)
    );
    // this.choosePlanFormGroup.addControl("hasDiscountCode", new FormControl(this.myUser.hasDiscountCode))
    // this.choosePlanFormGroup.addControl("selectOrganization", new FormControl(this.myUser.selectOrganization))
    // this.choosePlanFormGroup.addControl("discountCode", new FormControl(this.myUser.discountCode))
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  setPaymentType(chosenPaymentType) {
    this.chosenPlan = chosenPaymentType;
    this.planPaymentType = chosenPaymentType;
    switch (chosenPaymentType) {
      case "perYear":
        this.paymentFee = 72;
        this.paymentPeriod = "year";
        break;
      case "perMonth":
        this.paymentFee = 8;
        this.paymentPeriod = "month";
        break;
    }
  }

  async onSubmit() {
    this.submitted = true;
    if (this.choosePlanFormGroup.invalid) {
      return;
    }
    var chargebeeInstance = window["Chargebee"].init({
      site: this.zenplansDataService.chargeBeeSite,
    });
    var self = this;
    chargebeeInstance.openCheckout({
      hostedPage: function () {
        // We will discuss on how to implement this end point in the next step.
        return self.zenplansDataService.chargeBeeCheckout({
          plan: self.chosenPlan == "perMonth" ? "monthly" : "annual",
        });
      },
      success: async function (hostedPageId) {
        // success callback
        let res = await self.zenplansDataService.chargeBeeSaveSubscriptionId(
          hostedPageId
        );
        let myPlanHolder = await self.zenplansDataService.getUser()
        if (res.success) {
          if (myPlanHolder.userType == 'planHolder') {
            self.router.navigate(["/security-page-sign-up"])
          } else {
            self.router.navigate(["/home"]);
          }
        } else {
          alert("Something failed when saving the subscription information.");
        }
      },
      error: function () {
        alert(
          "Sorry, an error occurred, please log-in and try again, or contact support."
        );
        self.zenplansDataService.logout();
        self.router.navigate(["/log-in"]);
      },
    });

    // // Form Payment Type
    // this.choosePlanFormGroup.value["planPaymentType"] = this.planPaymentType;
    //
    // // Form Discound
    // this.myUser["planPaymentType"] = this.choosePlanFormGroup.value["planPaymentType"];
    // this.myUser["hasDiscountCode"] = this.choosePlanFormGroup.value["hasDiscountCode"];
    // // this.myUser["selectOrganization"] = this.choosePlanFormGroup.value["selectOrganization"];
    // this.myUser["discountCode"] = this.choosePlanFormGroup.value["discountCode"];
    //
    // await this.zenplansDataService.updateUser(this.myUser);
    // this.router.navigate(['/payment-monthly-subscription' + this.myUser.Id])
  }

  //   this.router.navigate(['/payment-monthly-subscription' + this.myUser.Id])

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
    this.footerVisibilityService.hideFooter = false;
  }
}
